const eventNames = {
  /** Triggered when a feed has finished loading its content */
  FEED_LOADED: "feed:loaded",
  /** Triggered when a feed loads more content (lazy loading/pagination) */
  FEED_LOADED_MORE: "feed:loaded:more",
  /** Triggered when an error occurs during feed loading or processing */
  FEED_ERROR: "feed:error"
};
const dispatch = (element, eventName, detail) => {
  const event = new CustomEvent(eventName, {
    detail,
    bubbles: true,
    cancelable: true
  });
  return element.dispatchEvent(event);
};
export {
  dispatch,
  eventNames
};
//# sourceMappingURL=index.js.map
